import gsap from "gsap";
import { pageReady } from "../../utils/page-ready";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { startSvgGlitch } from "../global/anim";

gsap.registerPlugin(ScrollTrigger);

const REVEAL_DURATION = 0.05;
const REVEAL_STAGGER = 0.03;
// Desyncs each icon's build-up from the others so they don't all glitch in
// at the exact same moment.
const ICON_STAGGER = 0.15;
const AMBIENT_DELAY = 1;

export default class IconsList {
  constructor(el) {
    this.el = el;
    this.icons = [...el.querySelectorAll("[data-svg]")];
    if (!this.icons.length) return;

    this.icons.forEach((icon) => {
      const paths = icon.querySelectorAll("path");
      if (paths.length) gsap.set(paths, { opacity: 0 });
    });

    const start = el.dataset.animStart || "top 85%";
    ScrollTrigger.create({ trigger: el, start, once: true, onEnter: () => pageReady.ready.then(this.play) });
  }

  play = () => {
    this.icons.forEach((icon, i) => {
      const paths = [...icon.querySelectorAll("path")];
      if (!paths.length) return;
      const order = [...paths].sort(() => Math.random() - 0.5);
      gsap.to(order, {
        opacity: 1,
        duration: REVEAL_DURATION,
        ease: "steps(1)",
        stagger: REVEAL_STAGGER,
        delay: i * ICON_STAGGER,
        onComplete: () => startSvgGlitch(icon, AMBIENT_DELAY),
      });
    });
  };
}
